import { useEffect, useState } from "react";
import { getAppName } from "@/components/shapes/connection-frame/app-icons";
import { resolveAppVisual, type AppVisual } from "@/lib/work-toast-app-visuals";
import type { WorkToastAppRef } from "@/stores/work-toast-store";

/** Resolve an app ref through the per-window cache when it carries no icon. */
export function useWorkToastAppVisual(ref: WorkToastAppRef): {
  label: string;
  iconUrl: string | null;
} {
  const [resolved, setResolved] = useState<{
    appId: string;
    visual: AppVisual | null;
  } | null>(null);
  useEffect(() => {
    if (ref.iconUrl) return;
    let live = true;
    void resolveAppVisual(ref.appId, ref.route).then((visual) => {
      if (live) setResolved({ appId: ref.appId, visual });
    });
    return () => {
      live = false;
    };
  }, [ref.appId, ref.route, ref.iconUrl]);
  const visual = resolved?.appId === ref.appId ? resolved.visual : null;
  return {
    label: ref.label ?? visual?.label ?? getAppName(ref.appId),
    iconUrl: ref.iconUrl ?? visual?.iconUrl ?? null,
  };
}
